import { createFileRoute } from '@tanstack/react-router'
import { Loader2 } from 'lucide-react'
import { useCompany } from '@/hooks/use-company'
import { TasksView } from '@/components/tasks/tasks-view'

export const Route = createFileRoute('/(app)/company/tasks/')({
  component: CompanyTasksPage,
})

/**
 * Company-module Tasks page. Reuses the exact Productivity Tasks view
 * ({@link TasksView}), scoped to the selected company's tasks via
 * `companyScopeId`. Same components, same layout — only the data set differs
 * (this company's tasks that involve the current user vs. all of the user's
 * tasks on the Productivity page).
 */
function CompanyTasksPage() {
  const { selectedCompanyId, isLoading } = useCompany()

  if (isLoading || selectedCompanyId == null) {
    return (
      <div className="flex items-center justify-center min-h-[320px]">
        <Loader2 className="size-8 animate-spin text-muted-foreground" />
      </div>
    )
  }

  return <TasksView companyScopeId={selectedCompanyId} />
}
